import { useEffect, useRef, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';
import httpClient from '../../_util/api';
import ButtonMain from '../Button';
import CustomizedSnackbars from '../../shared/Snackbar/SnackBar';

// Forces existing students who registered before the orphan field existed
// to answer once. Cannot be dismissed until saved.
const OrphanStatusModal = () => {
  const snackbar_Ref = useRef();
  const [open, setOpen] = useState(false);
  const [orphan, setOrphan] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const checkOrphanStatus = async () => {
      try {
        const res = await httpClient.get('/students/my-profile');
        const student = res?.data?.student;
        if (student && student.orphan !== 'yes' && student.orphan !== 'no') {
          setOpen(true);
        }
      } catch (error) {
        console.error('Error checking orphan status:', error);
      }
    };
    checkOrphanStatus();
  }, []);

  const saveHandler = async () => {
    if (!orphan) {
      snackbar_Ref.current?.showMessage('error', 'Please select Yes or No', '', 'i-chk-circle');
      return;
    }
    setSaving(true);
    try {
      const res = await httpClient.put('/students/my-profile', { orphan });
      if (res?.status === 200) {
        setOpen(false);
      }
    } catch (error) {
      const msg = error?.response?.data?.message || 'Failed to save. Please try again.';
      snackbar_Ref.current?.showMessage('error', msg, '', 'i-chk-circle');
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <CustomizedSnackbars ref={snackbar_Ref} />
      <Dialog open={open} disableEscapeKeyDown fullWidth maxWidth="xs">
        <DialogTitle sx={{ fontWeight: 'bold' }}>Update Required</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            Please answer the following question to continue. This information is
            required for your scholarship record.
          </Typography>
          <TextField
            required
            select
            fullWidth
            label="Are you an orphan?"
            value={orphan}
            onChange={(e) => setOrphan(e.target.value)}
          >
            <MenuItem value="yes">Yes</MenuItem>
            <MenuItem value="no">No</MenuItem>
          </TextField>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <ButtonMain variant="green" onClick={saveHandler} disabled={saving}>
            {saving ? 'Saving...' : 'Save'}
          </ButtonMain>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default OrphanStatusModal;
